<template>
  <div class="help-sidebar-template">
    <v-btn
      v-show="$myVuetifyBreakpoint.contentxs"
      fixed
      color="primary"
      fab
      dark
      style="z-index: 5; top: 0; right: 0"
      @click="helpNavDrawer = true"
    >
      <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>
    <v-navigation-drawer
      v-if="$myVuetifyBreakpoint.contentsmAndUp || helpNavDrawer"
      v-model="helpNavDrawer"
      :mini-variant.sync="helpNavDrawerMini"
      :color="
        helpNavDrawerMini || isHelpNavDrawerFull
          ? 'transparent'
          : 'ol-lightergray'
      "
      right
      clipped
      app
      width="200"
      floating
      :mobile-breakpoint="600"
      :temporary="isHelpNavDrawerMini && !helpNavDrawerMini && helpNavDrawer"
      :class="{ 'cursor-pointer': helpNavDrawerMini }"
      style="z-index: 1; align-self: flex-start"
      :style="{ top: ($vuetify.breakpoint.mdAndUp ? '64' : '56') + 'px' }"
      class="pt-0"
    >
      <v-list class="help-sidebar mt-8">
        <v-list-item>
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              class="text-uppercase"
              style="font-weight: 600"
            >
              Need Help?
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-show="template.guideUrl"
          link
          :href="template.guideUrl"
          target="_blank"
        >
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-open-in-new</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title style="font-size: 0.875rem">
              Document Guide
              <!-- TODO fix terminology -->
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-show="template.authorUrl"
          link
          :href="template.authorUrl"
          target="_blank"
        >
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-open-in-new</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title style="font-size: 0.875rem">
              Author Contact Details
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          :href="supportLink"
        >
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-email-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title style="font-size: 0.875rem">
              {{ siteName }} Support
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="author">
          <v-list-item class="mx-n4 ol-teal darken-1">
            <v-list-item-icon class="pl-4 mr-3">
              <v-icon>mdi-file-document-box-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content class="pr-4">
              <v-list-item-title class="text-uppercase">
                Supported By
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="ol-lightgray mx-n4"
            light
          >
            <div class="content-avatar">
              <div
                v-if="helpNavDrawerMini"
                class="custom-avatar small-avatar"
              >
                <img
                  v-if="author.photoURL"
                  :alt="author.name + ' profile image'"
                  :src="author.photoURL"
                >
                <strong v-else>
                  {{ author.name[0] + (author.name.split(' ')[1][0] || '') }}
                </strong>
              </div>
            </div>

            <v-list-item-content class="content-avatar">
              <div
                v-if="!helpNavDrawerMini"
                class="custom-avatar"
              >
                <img
                  v-if="author.photoURL"
                  :alt="author.name + ' profile image'"
                  :src="author.photoURL"
                >
                <strong v-else>
                  {{ author.name[0] + (author.name.split(' ')[1][0] || '') }}
                </strong>
              </div>
              <v-list-item-title>
                {{ author.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { supportEmail, siteName } from '../config/app'

export default {
  name: 'DocumentHelp',
  props: {
    template: { type: Object, default: () => ({}) }
  },
  data: function () {
    return {
      supportLink: `mailto:${supportEmail}?subject=App%20Support`,
      helpNavDrawer: true,
      siteName,
      helpNavDrawerMini: true
    }
  },
  computed: {
    isHelpNavDrawerFull() {
      return this.$myVuetifyBreakpoint.contentlgAndUp
    },
    isHelpNavDrawerMini() {
      return !this.isHelpNavDrawerFull && !this.$myVuetifyBreakpoint.contentxs
    },
    isHelpNavDrawerIcon() {
      return !this.isHelpNavDrawerFull && !this.isHelpNavDrawerMini
    },
    author() {
      return (
        this.template.expertLawyer &&
        this.$gnp(this.usersById, this.template.expertLawyer)
      )
    }
  },
  watch: {
    helpNavDrawer: function (newVal, oldVal) {
      /* fix vuetify not handling temporary mini-variant overlay click properly
         basically, turn it back to mini-mode when overlay click triggers nav closure */
      if (!this.helpNavDrawer) {
        if (this.isHelpNavDrawerMini) {
          this.helpNavDrawerMini = true
          this.$nextTick(() => {
            this.helpNavDrawer = true
          })
        }
      }
    },
    isHelpNavDrawerFull: {
      handler: function (newVal, oldVal) {
        if (this.isHelpNavDrawerFull) {
          this.helpNavDrawerMini = false
          this.helpNavDrawer = true
        }
      },
      immediate: true
    },
    isHelpNavDrawerMini: {
      handler: function (newVal, oldVal) {
        if (this.isHelpNavDrawerMini) {
          this.helpNavDrawerMini = true
        }
      },
      immediate: true
    },
    isHelpNavDrawerIcon: {
      handler: function (newVal, oldVal) {
        if (this.isHelpNavDrawerIcon) {
          this.helpNavDrawer = false
          this.helpNavDrawerMini = false
        }
      },
      immediate: true
    }
  },
  beforeCreate() {
    this.mapGetters(['usersById'])
  },
  async created() {
    await this.$store.dispatch('get_knownUsers')
    if (!(this.template.expertLawyer in this.usersById)) {
      this.$loadUser(
        this.template.expertLawyer,
        'templates/' + this.template['.key']
      )
    }
  }
}
</script>

<style lang="scss">
.content-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;

  .custom-avatar {
    background-color: var(--v-primary-base);
    min-height: 56px;
    min-width: 56px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-height: 56px;
      max-width: 56px;
      border-radius: 50px;
    }
  }

  .small-avatar {
    min-height: 40px;
    min-width: 40px;
    margin-left: 8px;

    img {
      max-height: 40px;
      max-width: 40px;
    }
  }

  strong {
    color: white;
  }
}

.help-sidebar-template .v-navigation-drawer {
  .help-sidebar {
    background-color: var(--v-lightblue-base);

    .v-list-item,
    .v-icon {
      color: var(--v-primary-base);
    }
  }
}
</style>
